import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { RollInUseRow, StandOption } from "../models/RollsInUse";

export const getRollsInUse = async ({
	standId = null,
	signal,
}: {
	standId?: number | null;
	signal?: AbortSignal;
} = {}): Promise<RollInUseRow[]> => {
	const apiService = new MESApiService();
	// The procedure takes only @standId: the grid sorts and pages client-side.
	// The pagination parameters existed for the legacy procedure.
	const parameters: spParameter[] = [{ name: "standId", value: standId }];
	const resp = await apiService.callV2(
		"[ROLLS].[GetRollsInUseDataWeb]",
		parameters,
		signal,
	);
	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching rolls in use");
	}
	return get(resp, "data.tables[0].rows", []) as RollInUseRow[];
};

export const getStands = async ({
	signal,
}: {
	signal?: AbortSignal;
} = {}): Promise<StandOption[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2(
		"[MILL].[GetStands]",
		[{ name: "OnlyActives", value: true }],
		signal,
	);
	if (resp.ok) return get(resp, "data.tables[0].rows", []) as StandOption[];
	throw new Error(resp.message || "Error fetching stands");
};
